// Open the CoPilot with a message (LD-3/LD-7, Launch Desktop PRD). Used by a meeting note's
// "Ask CoPilot" button. (Drafts go to the meeting's Paperclip agent instead — One Task System, OT-3.) In Launch Desktop's floating meeting panel — too narrow for
// the CoPilot — the desktop app opens it in the main window instead (window.launchDesktop bridge).

interface CopilotCtx {
  copilotContext: any;
  setCopilotContext: (c: any) => void;
  setCopilotOpen: (open: boolean) => void;
}
interface DesktopBridge { isPanel?: boolean; askCopilot?: (prompt: string) => void }

const desktop = (): DesktopBridge | undefined => (typeof window !== "undefined" ? (window as any).launchDesktop : undefined);

export const askCopilot = (ctx: CopilotCtx, prompt?: string) => {
  const d = desktop();
  if (d && d.isPanel && d.askCopilot) {
    d.askCopilot(prompt || "");
    return "desktop";
  }
  if (prompt) ctx.setCopilotContext({ ...(ctx.copilotContext || {}), query: prompt });
  ctx.setCopilotOpen(true);
  return "here";
};

// The meeting note's CoPilot request, worded so the CoPilot knows what to do.
export const askPrompt = (note: string, meeting: string) =>
  `Help me with this note from the live meeting "${meeting}": ${note}`;

// Put the cursor in the CoPilot's text box (the desktop shortcut opens the panel ready to type).
// The panel draws a moment after it opens, so look for the box for up to ~3 seconds.
const COPILOT_BOX = 'textarea[placeholder^="Ask or tell the CoPilot"], textarea[placeholder^="Ask Launch OS"]';
export const focusCopilotBox = (every = 100, tries = 30) => {
  let left = tries;
  const look = () => {
    const box = document.querySelector<HTMLTextAreaElement>(COPILOT_BOX);
    if (box) return box.focus();
    if (--left > 0) setTimeout(look, every);
  };
  setTimeout(look, every);
};
